export default "//cdn.scentbird.com/assets/frontbird-site/images/except-mobile_417623.gif";